module.exports = __webpack_public_path__ + "img/account_balance_wallet_opsz20.a191f020.svg";